// Typed wrapper around GET /api/tests/{id}/track_position — lap-position
// context (speed + lap distance) for a track-replay Study, on the SAME
// clock as every run's waveform_json time axis. Always 200: unavailable
// studies return {available:false, reason} and the strip simply doesn't
// render.
import { z } from "zod";

export const TrackPositionAvailableSchema = z.object({
  available: z.literal(true),
  track_code: z.string(),
  lap: z.string(),
  time_s: z.array(z.number()),
  lap_dist_m: z.array(z.number()),
  speed_mps: z.array(z.number()),
  lap_length_m: z.number().nullable(),
  duration_s: z.number(),
  sample_count: z.number().int(),
  units: z.object({ speed: z.string(), distance: z.string() }),
  meta: z.record(z.string(), z.unknown()),
});

export const TrackPositionUnavailableSchema = z.object({
  available: z.literal(false),
  reason: z.string(),
  lap: z.string().optional(),
});

export const TrackPositionResponseSchema = z.union([
  TrackPositionAvailableSchema,
  TrackPositionUnavailableSchema,
]);

export type TrackPositionAvailable = z.infer<
  typeof TrackPositionAvailableSchema
>;
export type TrackPositionResponse = z.infer<
  typeof TrackPositionResponseSchema
>;

export async function fetchTrackPosition(
  testId: number,
  opts: { maxPoints?: number; signal?: AbortSignal } = {},
): Promise<TrackPositionResponse> {
  const qs = opts.maxPoints ? `?max_points=${opts.maxPoints}` : "";
  const r = await fetch(`/api/tests/${testId}/track_position${qs}`, {
    signal: opts.signal,
  });
  if (!r.ok) {
    throw new Error(
      `GET /api/tests/${testId}/track_position failed: ${r.status}`,
    );
  }
  return TrackPositionResponseSchema.parse(await r.json());
}
